export default __webpack_public_path__ + "img/skjold.694e0fe2.jpg";